import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Button, Switch } from 'antd';
import { 
  UserOutlined, ProfileTwoTone, PhoneTwoTone, PieChartTwoTone, 
  MenuFoldOutlined, MenuUnfoldOutlined
} from '@ant-design/icons';
import { getLocalStorageInfo } from '../utils/Common';
import { isMobile } from "react-device-detect";



const { Sider } = Layout;

const NavBarLayout = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [theme, setTheme] = useState('light');
  const [mode, setMode] = useState('vertical');
  const [curMenu, setCurMenu] = useState('');

  const changeMode = (checked) => setMode(checked ? 'inline' : 'vertical');
  // const changeTheme = (checked) => setTheme(checked ? 'dark' : 'light');
  const handleClick = (e) => {
    setCurMenu('');
    setCurMenu(e.key);
  };
  const toggleCollapsed = () => setCollapsed(!collapsed);

  const userInfo = getLocalStorageInfo('curUser');
  // console.log('User info ', userInfo);

  const menuAdminItems = [
    {
      key: 'userSection',
      label: 'ユーザー管理',
      icon: <UserOutlined />,
      children: [
        { key: 'userList', label: <Link to='/homeAdmin/user-manager'>ユーザー一覧 </Link> },
        // { key: 'userGroup', label: <Link to='/homeAdmin/user-group'>グループユーザー </Link> },
        { key: 'departmentList', label: <Link to='/homeAdmin/department'>部署一覧 </Link> },
      ],
    },
    {
      key: 'projectSection',
      label: 'プロジェクト管理',
      icon: <ProfileTwoTone />,
      children: [
        { key: 'workgroupList', label: <Link to='/homeAdmin/work-groups'>リスト会社 </Link> },
        { key: 'projectList', label: <Link to='/homeAdmin/project-list'>プロジェクトの一覧 </Link> },
      ],
    },
    {
      key: 'callCenterSection',
      label: 'コールセンター',
      icon: <PhoneTwoTone />,
      children: [
        { key: 'callList', label: <Link to='/homeAdmin/call-meeting'>通話リスト</Link> },
        { key: 'automatic-distribution', label: <Link to='/homeAdmin/automatic-distribution'>自動配布コールモード</Link> },
        // { key: 'candidateList', label: <Link to='/homeAdmin/candidate-list'>候補者リスト</Link> },
        { key: 'callLogs', label: <Link to='/homeAdmin/call-logs'>to C コールログ</Link> },
        { key: 'callLogs-enterprise', label: <Link to='/homeAdmin/call-logs?is_enterprise=1'>to B コールログ</Link> },
        // { key: 'callRecording', label: <Link to='/homeAdmin/call-recording'>通話録音 </Link> },
        // { key: 'callTwilio', label: <Link to='/homeAdmin/call-twilio'>Twilio 通話 </Link> },
      ],
    },
    {
      key: 'callReportSection',
      label: '通話レポート',
      icon: <PieChartTwoTone />,
      children: [
        { key: 'zoomCallReport', label: <Link to='/homeAdmin/call-report-zoom'>レポート</Link> },
        // { key: 'dataFromGGS', label: <Link to='/homeAdmin/gss-list'>GSSからのデータ</Link> },
        // { key: 'dataToGGS', label: <Link to='/homeAdmin/gss-sync'>GGSにデータを同期する</Link> },
      ],
    },
  ];

  const menuUserItems = [
    {
      key: 'callCenterSection',
      label: 'Call Center',
      icon: <PhoneTwoTone />,
      children: [
        { key: 'callList', label: <Link to='/homeAdmin/call-meeting'>通話リスト </Link> },
        { key: 'automatic-distribution', label: <Link to='/homeAdmin/automatic-distribution'>自動配布コールモード </Link> },
        { key: 'callLogs', label: <Link to='/homeAdmin/call-logs'>to C コールログ</Link> },
        { key: 'callLogs-enterprise', label: <Link to='/homeAdmin/call-logs?is_enterprise=1'>to B コールログ</Link> },
        // { key: 'callRecording', label: <Link to='/homeAdmin/call-recording'>通話録音 </Link> },
      ],
    },
    {
      key: 'callReportSection',
      label: '通話レポート',
      icon: <PieChartTwoTone />,
      children: [
        { key: 'zoomCallReport', label: <Link to='/homeAdmin/call-report-zoom'>レポート</Link> },
        // { key: 'dataFromGGS', label: <Link to='/homeAdmin/gss-list'>GSSからのデータ</Link> },
        // { key: 'dataToGGS', label: <Link to='/homeAdmin/gss-sync'>GGSにデータを同期する</Link> },
      ],
    },

  ];

  const menuItems = (userInfo?.is_admin) ? menuAdminItems :  menuUserItems;


 return (
  <>
    {/* モバイル時のオーバーレイ */}
    {isMobile && !collapsed && (
      <div
        onClick={() => setCollapsed(true)}
        style={{ position: 'fixed', inset: 0, zIndex: 999 }}
      />
    )}

    {/* モバイル時はボタンをSiderの外・Header上に固定 */}
    {isMobile && (
      <Button
        type="primary"
        onClick={toggleCollapsed}
        style={{
          position: 'fixed',
          top: 12,
          left: 12,
          zIndex: 1100,
          width: 40,
          height: 40,
          minWidth: 'unset',
          padding: 0,
        }}
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </Button>
    )}

    <Sider
      width={isMobile ? 200 : 260}
      theme={theme}
      collapsed={collapsed}
      onCollapse={setCollapsed}
      style={{
        ...(isMobile && {
          position: 'fixed',
          zIndex: 1000,
          height: '100vh',
          top: 64,
          left: collapsed ? '-260px' : '0',
          transition: 'left 0.25s ease',
          overflow: 'hidden',
        }),
      }}
    >
      <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {/* PCのみボタンとSwitchをSider内に表示 */}
        {!isMobile && (
          <>
            <Switch
              checkedChildren="Vertical"
              unCheckedChildren="Inline"
              onChange={changeMode}
            />
            <Button
              type="primary"
              onClick={toggleCollapsed}
              style={{ marginBottom: 16 }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
          </>
        )}
      </div>
      <Menu
        selectedKeys={[curMenu]}
        mode={mode}
        theme={theme}
        items={menuItems}
        onClick={handleClick}
      />
    </Sider>
  </>
);
};

export default NavBarLayout;
